<template>
    <div id="schoolSignupNoticeList">
        <div class="second-header-wrap">
            <!--<el-button type="primary" @click="batchSignup" size="medium" v-if="&&state==0&&!groupId&&groupTableList.length>0">自动审核</el-button>-->
            <el-button type="primary" @click="batchSignup" size="medium"
                       v-if="leftGroupList==''&&noticeState==3&&yearNum.indexOf(new Date().getFullYear())!==-1&&groupTableList&&groupTableList.length>0"
                       class="auto-btn">自动审核
            </el-button>

            <div style="float: left;">
                <el-select v-model="noticeId" size="medium" @change="noticeChange" placeholder="请选择" v-if="!groupId">
                    <el-option
                        v-for="noticeItem in noticeList"
                        :key="noticeItem.id"
                        :label="noticeItem.title"
                        :value="noticeItem.id">
                    </el-option>
                </el-select>
                <el-select v-model="selectState" @change="stateHandler" size="medium" placeholder="请选择">
                    <el-option label="全部" value="0"></el-option>
                    <el-option :label="stateItem.stateName" :value="stateItem.state" v-for="stateItem in stateList"></el-option>
                </el-select>
                <el-input style="width: 200px;" size="medium" v-model.trim="searchVal"
                          @keyup.native.enter="searchHandler" placeholder="请输入身份证号或姓名"></el-input>
                <el-button type="primary" @click="searchHandler" size="medium">搜索</el-button>
                <el-button type="primary" v-if="!groupId" @click="toSignupAdd" size="medium">补录</el-button>
                <a v-if="!type" :href="exportAllURL" download="导出" target="_blank">
                    <el-button class="filter-item" type="primary" icon="upload" size="medium">导出详细数据</el-button>
                </a>
                <el-button v-show="!groupId" class="filter-item" type="primary" icon="upload" size="medium" @click="downloadPhotos">下载学生照片</el-button>
                <el-button v-show="!groupId" class="filter-item" type="primary" size="medium" @click="jumpToPage('/main/primary/OccupiedStudentList', {noticeId, groupId, type})">学位被占学生</el-button>
            </div>
        </div>
        <div class="table-container">
            <el-table
                ref="messageTable"
                :data="groupTableList"
                class="messageTable custom—scrollbar"
                fit
                style="width: 100%"
                border
            >
                <el-table-column
                    label="序号" align="center" show-overflow-tooltip width="120">
                    <template slot-scope="scope">
                        {{scope.row.orderNo}}
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="hasApplyNo"
                    label="报名编号" align="center" show-overflow-tooltip width="120">
                    <template slot-scope="scope">
                        {{scope.row.applyNo}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="姓名" align="center" show-overflow-tooltip width="120">
                    <template slot-scope="scope">
                        <router-link v-if="groupId"
                                     :to="{path: 'signupDetail', query: {stuId: scope.row.id, noticeId, orderNo: scope.row.orderNo,groupId:groupId,type:type}}">
                            {{scope.row.stuName}}
                        </router-link>
                        <router-link v-if="!groupId"
                                     :to="{path: 'signupDetail', query: {stuId: scope.row.id, noticeId, orderNo: scope.row.orderNo}}">
                            {{scope.row.stuName}}
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column
                    label="性别" align="center" width="60">
                    <template slot-scope="scope">
                        <span>{{scope.row.gender === 1 ? '男' : '女'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="出生日期" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{scope.row.birthday}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="身份证/护照" align="center" show-overflow-tooltip width="200">
                    <template slot-scope="scope">
                        {{scope.row.idCard}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="联系电话" align="center">
                    <template slot-scope="scope">
                        {{scope.row.loginPhone}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="报名时间" align="center" width="160">
                    <template slot-scope="scope">
                        {{scope.row.createTime | timeSuffixFilter}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="状态" align="center">
                    <template slot-scope="scope">
                        <span>{{['未分组', '待审核', '已审核', '已录取', '二审通过', '二审不通过', '待确认', '驳回一审', '预录取'][scope.row.state]}}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="居住确认状态" align="center" width="160">
                   <template slot-scope="scope">
                       <el-tag type="success" v-if="scope.row.isLiveActual==1">确定实际居住</el-tag>
                       <el-tag type="danger" v-if="scope.row.isLiveActual==2">疑似非实际居住</el-tag>
                       <el-tag type="danger" v-if="scope.row.isLiveActual==3">确定非实际居住</el-tag>
                       <el-tag type="info" v-if="scope.row.isLiveActual==0">未确认</el-tag>
                   </template>
               </el-table-column> -->
                <el-table-column
                    label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button size="small" type="text" @click="secondHanlder(scope.row.id)"
                                   v-if="scope.row.lineExamState == 0 && (secondControl==3 || secondControl==2 || secondControl==4)">
                            二审
                        </el-button>
                        <el-button size="small" type="text" @click="liveConfirm(scope.row.id)">
                            <span v-if="scope.row.isLiveActual!=0">再次居住确认</span>
                            <span v-else>居住确认</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-container">
            <el-pagination
                @size-change="sizeChangeHandler"
                @current-change="currentChangeHandler"
                :current-page.sync="pageNo"
                :page-sizes="[10 , 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total" v-if="total!=0"
            >
            </el-pagination>
        </div>
        <el-dialog :close-on-click-modal='false' title="二审" :visible.sync="examVisible" class="addExamBox">
            <el-form :model="firstExamineQuery" ref="firstExamObject" :rules="firstExamineRule" label-width="140px">
                <el-form-item label="二审结果" class="numberBox">
                    <el-radio-group v-model="firstExamineQuery.examineResult">
                        <el-radio :label="1">通过</el-radio>
                        <el-radio :label="2">不通过</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-show="firstExamineQuery.examineResult === 2" label="意见备注" class="numberBox" prop="examinOptions">
                    <el-input
                        type="textarea"
                        :rows="3"
                        :maxlength="100"
                        placeholder="请输入意见"
                        v-model="firstExamineQuery.examinOptions">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="examVisible=false">取 消</el-button>
                <el-button size="medium" type="primary" @click="addTimeHandler()">保 存</el-button>
            </div>
        </el-dialog>
        <!-- 居住确认 -->
        <el-dialog :close-on-click-modal='false' title="实际居住确认" :visible.sync="dialogVisible" width="60%">
            <div>
                <el-form :model="queryList" label-width="100px" :rules="singleRules" ref="single">
                    <el-form-item label="居住情况" prop="liveActual">
                        <el-radio-group v-model="queryList.liveActual">
                            <el-radio :label="1">确定实际居住</el-radio>
                            <el-radio :label="2">疑似非实际居住</el-radio>
                            <el-radio :label="3">确定非实际居住</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="备注内容" prop="liveRemark">
                        <el-input type="textarea" v-model.trim="queryList.liveRemark" :maxlength="100"></el-input>
                    </el-form-item>
                </el-form>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="determine()">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import {
        getSchoolEnrolNoticeList,
        getNoticeApplyStuPageList,
        autoExamineApplyStudents,
        getGroupApplyStuPageList,
        getNoticeGroupList,
        secondExamine,
        markStuLiveActual,
        exportAllStuAndAllPicList,
        getNoticeStuStateList
    } from '@/api/primary/setting.js';
    import {
        getSchoolEnrolFieldList,
    } from '@/api/primary/review';
    import baseMixin from '@/mixins/baseMixin';
    import {mapGetters} from 'vuex';

    export default {
        name: "SignupList",
        data() {
            const firstExamineOptionValidator = (rule, value, callback) => {
                if(this.firstExamineQuery.examineResult === 2 && this.firstExamineQuery.examinOptions === '') {
                    callback(new Error('审核意见不能为空！'));
                } else {
                    callback();
                }
            };

            return {
                stateList: [],
                state: '',
                noticeId: '',
                groupTableList: [],
                searchVal: '',
                pageNo: 1,
                pageSize: 10,
                total: 0,
                groupId: '',
                type:'',
                noticeList: [],
                leftGroupList: [],
                noticeState: 1,
                yearNum: '',
                selectState: 0,
                selection: [],
                secondControl: '',
                examVisible: false,
                dialogVisible: false,
                examineResult: '',
                firstExamineQuery: {
                    examineResult: 1,
                    examinOptions: '',
                },
                firstExamineRule: {
                    examinOptions: [{
                        required: true, validator: firstExamineOptionValidator, trigger: 'blur'
                    }]
                },
                studentId: '',
                queryList: {
                    liveActual: 1,
                    stuId: '',
                    liveRemark: ''
                },
                singleRules: {
                    liveActual: [{
                        required: true, message: '请选择居住情况', trigger: 'blur'
                    }],
                    liveRemark: [{
                        required: true, message: '备注内容不能为空', trigger: 'blur'
                    }],

                },
            }
        },
        watch: {
            '$route': {
                handler: function (to, from) {
                    if (to.query&&to.path.indexOf("primary/signup")!==-1) {
                        this.query = to.query;
                        if(Object.keys(this.query).length!==0){
                            this.state = this.query.state;
                            this.secondControl = this.query.type;
                            this.groupId = this.query.groupId;
                            this.type=this.query.type;
                            this.noticeId = this.query.noticeId;
                            if (this.noticeId) {
                                this.searchVal = '';
                                this.state = 0;
                                this.selectState = 0;
                            }

                            this.getSchoolEnrolNoticeListFunc();
                        }

                    }
                },
                immediate: true,
                hasApplyNo: true
            }
        },
        computed: {
            ...mapGetters(['userInfo']),
            exportAllURL: function() {
                return `${global.BasePath}structure/staterunEnrol/exportApplyStuListBySchool?noticeId=${this.noticeId}&state=0&token=${this.$store.getters.token}`;
            }
        },
        created() {
            this.getSchoolEnrolFieldListFunc();
        },
        mounted() {
        },

        // beforeRouteLeave(to,from,next){
        //     console.log(to.name)
        //     if(to.name=='signupDetail'){
        //         from.meta.keepAlive=true;
        //         next();
        //     }else{
        //         from.meta.keepAlive=false;
        //         this.$destroy();
        //         next();
        //     }
        // },
        mixins: [baseMixin],
        methods: {
            getSchoolEnrolFieldListFunc(){
                getSchoolEnrolFieldList({
                    yearNo:this.$moment(new Date()).format('YYYY')
                })
                    .then(res=>res.data)
                    .then(data=>{
                        if(data.code===200){
                            this.hasApplyNo = data.data.findIndex(item => item.fieldName === 'applyNo') !== -1;
                        }
                    })
            },
            getNoticeStuStateListFunc() {
                return getNoticeStuStateList({
                    noticeId: this.noticeId,
                })
                    .then(res => res.data)
                    .then(data => {
                        console.log('dd', data.data)
                        this.stateList = data.data;
                    });
            },
            addTimeHandler() {
                this.$refs.firstExamObject.validate((valid) => {
                    if (valid) {
                        this.examVisible = false;
                        secondExamine({
                            examinOptions: this.firstExamineQuery.examineResult === 1 ? '' : this.firstExamineQuery.examinOptions,
                            examineResult: this.firstExamineQuery.examineResult,
                            groupId: this.groupId,
                            noticeId: this.noticeId,
                            studentId: this.studentId
                        }).then(res => res.data)
                            .then(data => {
                                if (data.code === 200) {

                                    this.$message({
                                        type: 'success',
                                        message: '审核完成！'
                                    });
                                    this.listAll();
                                }
                            })
                    }
                });
            },
            secondHanlder(id) {
                this.studentId = id;
                this.examVisible = true;
            },
            stateHandler(val) {
                this.pageNo = 1;
                this.selectState = val;
                this.state = this.selectState;
                this.listAll();
            },
            noticeChange(val) {
                this.pageNo = 1;
                this.noticeId = val;
                this.state = 0;
                this.selectState = 0;
                this.searchVal = '';
                let noticeItem = this.noticeList.find(item =>
                    this.noticeId == item.id
                );
                this.noticeState = noticeItem.noticeState;
                this.yearNum = noticeItem.yearNum;
                this.$emit('noticeIdBack', {noticeId: this.noticeId});
                // this.getNoticeApplyStuPageListFunc();
                this.getNoticeStuStateListFunc()
                    .then(() => {
                        this.listAll();
                        this.getNoticeGroupListFunc();
                    })

            },
            batchSignup() {
                autoExamineApplyStudents({
                    noticeId: this.noticeId
                }).then(res => res.data)
                    .then(data => {
                        if (data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '自动审核成功！'
                            });
                            this.$emit('noticeIdBack', {noticeId: this.noticeId});
                            //  this.$emit('noticeIdBack',this.noticeId);
                            this.getNoticeStuStateListFunc()
                                .then(() => {
                                    this.listAll();
                                    this.getNoticeGroupListFunc();
                                })

                        } else {
                            this.$message({
                                type: 'error',
                                message: data.msg
                            });
                        }
                    })
            },
            sizeChangeHandler(pageSize) {
                this.pageSize = pageSize;
                this.pageNo = 1;
                //this.getSchoolEnrolNoticeListFunc();
                this.listAll(false);
            },
            currentChangeHandler(pageNo) {
                this.pageNo = pageNo;
                this.listAll(false);
                //this.getSchoolEnrolNoticeListFunc();
            },
            searchHandler() {
                this.pageNo = 1;
                this.listAll(false);
                //this.getNoticeApplyStuPageListFunc();
            },
            getSchoolEnrolNoticeListFunc() {
                getSchoolEnrolNoticeList({
                    searchVal: '',
                    state: 2
                }).then(res => res.data)
                    .then(data => {
                        if (data.code === 200) {
                            if (data.data && data.data.length !== 0) {
                                let groupList = data.data;
                                this.noticeList = data.data;
                                if (this.noticeId) {
                                    let noticeItem = this.noticeList.find(item =>
                                        this.noticeId == item.id
                                    );
                                    this.noticeState = noticeItem.noticeState;
                                    this.noticeId = noticeItem.id;
                                    this.yearNum = noticeItem.yearNum;
                                    this.getNoticeStuStateListFunc()
                                        .then(() => {
                                            this.listAll();
                                            this.getNoticeGroupListFunc();
                                        })
                                } else {
                                    this.noticeId = groupList[0].id;
                                    this.noticeState = groupList[0].noticeState;
                                    this.yearNum = groupList[0].yearNum;
                                    this.$emit('noticeIdBack', {noticeId: this.noticeId});
                                    this.getNoticeStuStateListFunc()
                                        .then(() => {
                                            this.listAll();
                                            this.getNoticeGroupListFunc();
                                        })
                                }
                            }
                        }
                    })
            },
            getNoticeGroupListFunc() {
                getNoticeGroupList({
                    noticeId: this.noticeId
                }).then(res => res.data)
                    .then(data => {
                        if (data.code === 200) {
                            if (data.data) {
                                this.leftGroupList = data.data;
                            }
                        }
                    })
            },
            listAll(isChangeGroup = true) {
                if (!this.groupId && this.noticeId) {
                    this.getNoticeApplyStuPageListFunc()
                }
                if (this.groupId) {
                    if(isChangeGroup) {
                        this.pageNo = 1;
                    }
                    this.getGroupApplyStuPageListFunc()

                }
            },
            getGroupApplyStuPageListFunc() {
                getGroupApplyStuPageList({
                    groupId: this.groupId,
                    searchVal: this.searchVal,
                    state: this.state,
                    pageNo: this.pageNo,
                    pageSize: this.pageSize
                }).then(res => res.data)
                    .then(data => {
                        if (data.code === 200) {
                            this.groupTableList = data.data.dataList;
                            this.total = data.data.pagination.total;
                        }
                    })
            },
            getNoticeApplyStuPageListFunc() {
                getNoticeApplyStuPageList({
                    noticeId: this.noticeId,
                    searchVal: this.searchVal,
                    state: this.state,
                    pageNo: this.pageNo,
                    pageSize: this.pageSize
                }).then(res => res.data)
                    .then(data => {

                        if (data.code === 200) {
                            this.groupTableList = data.data.dataList;
                            if(this.groupTableList.length==0&&this.pageNo>1){
                                this.pageNo--;
                                this.getNoticeApplyStuPageListFunc();
                            }
                            this.total = data.data.pagination.total;
                        }
                    })
            },
            //居住确认弹出框
            liveConfirm(id) {
                this.dialogVisible = true;
                this.queryList.stuId = id;
            },
            //确认居住
            determine() {
                this.$refs.single.validate((valid) => {
                    if (valid) {
                        markStuLiveActual(this.queryList)
                            .then(res => res.data)
                            .then(data => {
                                if (data.result) {
                                    this.dialogVisible = false;
                                    this.queryList.liveRemark = '';
                                    this.queryList.liveActual = 1;
                                    this.$message({
                                        message: '居住情况已确认成功',
                                        type: 'success'
                                    });
                                    this.listAll();
                                }
                            });
                    }
                });
            },
            toSignupAdd() {
                // <router-link v-if="groupId" 
                //             :to="{path: 'signupDetail', query: {stuId: scope.row.id, noticeId, orderNo: scope.row.orderNo,}}">
                //             {{scope.row.stuName}}
                //         </router-link>
                //         <router-link v-if="!groupId" 
                //             :to="{path: 'signupDetail', query: {stuId: scope.row.id, noticeId, orderNo: scope.row.orderNo}}">
                //             {{scope.row.stuName}}
                //         </router-link>
                if(this.groupId){
                    this.$router.push({
                        path: 'signupAdd',
                        query: {
                            noticeId: this.noticeId,
                            schoolId: this.noticeList.find(({id}) => id === this.noticeId).schoolId,
                            groupId:this.groupId,
                            type:this.type
                        }
                    });
                }
                if(!this.groupId){
                    this.$router.push({
                        path: 'signupAdd',
                        query: {
                            noticeId: this.noticeId,
                            schoolId: this.noticeList.find(({id}) => id === this.noticeId).schoolId
                        }
                    });
                }
            },
            downloadPhotos() {
                exportAllStuAndAllPicList({
                    noticeId: this.noticeId,
                    state: this.selectState
                })
                    .then(res => res.data)
                    .then(data => {
                        console.log(data.data);
                        if(data.result) {
                            const prefixUrl = global.command === 'production' ? 'https://www.zhxiaoyuan.cn/' : 'http://api.weixiaojia.net/';
                            window.open(`${prefixUrl}thunder/archive/getArchiveByKey?archiveName=${data.data.zipName}&key=${data.data.key}&token=${this.$store.getters.token}`, "_blank");
                        } else {
                            this.$message.error(data.msg);
                        }
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin.scss";

    .table-container {
        width: 92%;
        min-width: 1200px;
    }

    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        background-color: #fff;
        z-index: 1000;
        padding: 20px 0 0 0;
        margin-bottom: 20px;
        @include clearfix;

        .auto-btn {
            float: left;
            margin-right: 10px;
        }
    }

    .main-wrap {
        width: 100%;
        margin-top: 229px;
    }

    .main-container {
        width: 1320px;
        padding: 30px 10px;
        margin: 0 auto;
        min-height: 560px;
    }

    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }

    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }

    .pagination-container {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }
</style>
<style>
    #schoolSignupNoticeList a {
        color: #409EFF;
        text-decoration: none;
    }
</style>




// WEBPACK FOOTER //
// src/views/primary/signup/SignupList.vue